import { sendGAEvent } from '@noths/polaris-client-google-analytics';

export const trackAddMembershipToBasket = () => {
  const trackAddToCart = {
    event: 'add_to_cart',
    event_action: 'Add to basket',
    event_category: 'Membership',
    event_label: 'Landing page',
    ecommerce: {
      add: {
        products: [
          {
            brand: 'NOTHS & More',
            dimension34: 'notonthehighstreetandmore',
            price: '10.00',
            dimension30: '1318048',
            id: '1308048',
            name: 'NOTHS & More Annual Membership',
            quantity: 1,
          },
        ],
      },
    },
  };
  sendGAEvent(trackAddToCart);
};

export const trackAddMembershipToBasketError = (errorMsg: string) => {
  const trackAddToBasketError = {
    event: 'custom_event',
    event_action: 'Error',
    event_category: 'Membership',
    event_label: errorMsg,
  };

  sendGAEvent(trackAddToBasketError);
};
